export default "__VITE_ASSET__Dwy5ozAS__"